import type { FC, ReactNode } from 'react'

import { useEffect, useRef, useState } from 'react'

import { gsap, registerGsap } from '@/lib/gsap'
import { Reveal } from '@/components/anim'

interface Testimonial {
    quote: string
    name: string
    role: string
    image: string
}

const testimonials: Testimonial[] = [
    {
        quote:
            'We have a flexible schedule because we use Manila. You can adjust to the work schedule that works best for you thanks to it.',
        name: 'Noah Mitchell',
        role: 'CEO @precisionco',
        image: '/images/Slider-Image-1.webp'
    },
    {
        quote:
            'We have a flexible schedule because we use Manila. You can adjust to the work schedule that works best for you thanks to it.',
        name: 'Ethan Montgomery',
        role: 'CEO @greenwave',
        image: '/images/Profile-Picture-05.webp'
    },
    {
        quote:
            'We have a flexible schedule because we use Manila. You can adjust to the work schedule that works best for you thanks to it.',
        name: 'Sophia Ramirez',
        role: 'CEO @stellartech',
        image: '/images/Profile-Picture-02.webp'
    }
]

export const TestimonialsSection: FC = (): ReactNode => {
    const [index, setIndex] = useState(0)
    const trackRef = useRef<HTMLDivElement | null>(null)
    const total = testimonials.length

    useEffect(() => {
        registerGsap()
        if (trackRef.current) {
            gsap.to(trackRef.current, { xPercent: -index * 100, duration: 0.5, ease: 'wfEase' })
        }
    }, [index])

    const prev = () => setIndex((current) => (current - 1 + total) % total)
    const next = () => setIndex((current) => (current + 1) % total)

    return (
        <div id='testimonial' className='section overflow-hidden'>
            <div className='container no-padding-top-mobile'>
                <div className='flex-center-text'>
                    <Reveal as='h2' className='hero-text'>
                        What our<span className='gradient-text _02'> costumers</span> are saying
                    </Reveal>
                    <div className='fixed-text'>
                        From financial metrics to sales and marketing data, our dashboard provides you
                        with a holistic view of your business operations.
                    </div>
                </div>

                <div className='slider-holder'>
                    <div className='slider w-slider'>
                        <div className='mask w-slider-mask'>
                            <div ref={trackRef} className='testimonial-track'>
                                {testimonials.map((item, i) => (
                                    <div className='slide w-slide' key={item.name} aria-hidden={i !== index}>
                                        <div className='slider-content-holder'>
                                            <div className='slider-header-container'>
                                                <div className='slider-profile-picture-holder'>
                                                    <div className='slider-profile-picture'>
                                                        <img
                                                            src={item.image}
                                                            loading='lazy'
                                                            alt={item.name}
                                                            className='slider-profile-picture-image'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='slider-header-content'>
                                                    <div className='card-title'>{item.quote}</div>
                                                    <div className='slider-person-content'>
                                                        <div className='qoute-person-details'>
                                                            <div className='person-name'>
                                                                <div>{item.name}</div>
                                                            </div>
                                                            <div className='person-job-location'>
                                                                <div>{item.role}</div>
                                                            </div>
                                                        </div>
                                                        <div className='qoute-icon-holder'>
                                                            <img
                                                                src='/images/quote-mark.svg'
                                                                loading='lazy'
                                                                alt=''
                                                                className='qoute-icon'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div
                            className='left-arrow w-slider-arrow-left'
                            role='button'
                            tabIndex={0}
                            aria-label='Previous testimonial'
                            onClick={prev}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault()
                                    prev()
                                }
                            }}
                        >
                            <div className='arrow-circle-holder white-background'>
                                <img src='/images/Left-Arrow.svg' loading='lazy' alt='' className='arrow-image' />
                            </div>
                        </div>
                        <div
                            className='right-arrow w-slider-arrow-right'
                            role='button'
                            tabIndex={0}
                            aria-label='Next testimonial'
                            onClick={next}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    event.preventDefault()
                                    next()
                                }
                            }}
                        >
                            <div className='arrow-circle-holder'>
                                <img src='/images/Arrow-White-RIght.svg' loading='lazy' alt='' className='arrow-image' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
